import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ebacbf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex gap-3 text-center" }
const _hoisted_3 = ["data-kt-indicator", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
    ref: "forgotPasswordForm",
    "validation-schema": _ctx.formSchema
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.submitForgotPasswordForm)), ["prevent"])
      }, [
        _createVNode(_component_FormField, {
          required: true,
          name: "email",
          value: values.email,
          formControlClass: "form-control form-control-lg text-login",
          showLabel: false,
          placeholder: "Email",
          type: "email"
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-new-design-secondary w-50 mb-5"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "submit",
            id: "kt_sign_in_submit",
            class: "btn w-50 mb-5 btn-new-design-primary",
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            onClick: validate
          }, _hoisted_6, 8, _hoisted_3)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}